// import React from 'react';
// import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

// const PaginationComponent = ({ currentPage, totalPages, handlePageChange, scrollpage }) => {
//   const pageNumbers = [...Array(totalPages).keys()].map(num => num + 1);

// const handleClick = (e,number) => {
//   if (scrollpage) {
//     e.preventDefault();
//   }
//   handlePageChange(number)

//   }
//   return (
//     <div className="d-flex justify-content-end mt-3"> {/* Aligns to the right and adds top margin */}
//       <Pagination aria-label="Page navigation">
//         {/* Previous Button */}
//         <PaginationItem disabled={currentPage === 1}>
//           <PaginationLink
//             previous
//             href="#"
//             onClick={(e) => handleClick(e,currentPage - 1)}
//           >Previous</PaginationLink>
//         </PaginationItem>

//         {/* Page Numbers */}
//         {pageNumbers.map(number => (
//           <PaginationItem key={number} active={number === currentPage}>
//             <PaginationLink href="#" onClick={(e) => handleClick(e,number)}>
//               {number}
//             </PaginationLink>
//           </PaginationItem>
//         ))}

//         {/* Next Button */}
//         <PaginationItem disabled={currentPage === totalPages}>
//           <PaginationLink
//             size="sm"
//             next
//             href="#"
//             onClick={(e) => handleClick(e,currentPage + 1)}
//           >Next</PaginationLink>
//         </PaginationItem>
//       </Pagination>
//     </div>
//   );
// };

import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const PaginationComponent = ({
  currentPage,
  totalPages,
  handlePageChange
}) => {
  const pageWindowSize = 5; // Number of pages in the window
  const startPage = Math.max(1, Math.floor((currentPage - 1) / pageWindowSize) * pageWindowSize + 1);
  const endPage = Math.min(startPage + pageWindowSize - 1, totalPages);

  const handleClick = (e, number) => {
    e.preventDefault(); // Prevent default link behavior
    handlePageChange(number); // Callback to parent
  };

  return (
    <div className="d-flex justify-content-end mt-3">
      {/* Pagination */}
      <Pagination aria-label="Page navigation">
        {/* Previous Button */}
        <PaginationItem disabled={currentPage === 1}>
          <PaginationLink
            previous
            href="#"
            onClick={(e) => handleClick(e, currentPage - 1)}
          />
        </PaginationItem>

        {/* First Page with Ellipsis */}
        {startPage > 1 && (
          <>
            <PaginationItem>
              <PaginationLink href="#" onClick={(e) => handleClick(e, 1)}>
                1
              </PaginationLink>
            </PaginationItem>
            <PaginationItem disabled>
              <PaginationLink href="#">...</PaginationLink>
            </PaginationItem>
          </>
        )}

        {/* Page Numbers */}
        {Array.from({ length: endPage - startPage + 1 }, (_, idx) => startPage + idx).map(number => (
          <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink href="#" onClick={(e) => handleClick(e, number)}>
              {number}
            </PaginationLink>
          </PaginationItem>
        ))}

        {/* Last Page with Ellipsis */}
        {endPage < totalPages && (
          <>
            <PaginationItem disabled>
              <PaginationLink href="#">...</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href="#" onClick={(e) => handleClick(e, totalPages)}>
                {totalPages}
              </PaginationLink>
            </PaginationItem>
          </>
        )}

        {/* Next Button */}
        <PaginationItem disabled={currentPage === totalPages}>
          <PaginationLink
            next
            href="#"
            onClick={(e) => handleClick(e, currentPage + 1)}
          />
        </PaginationItem>
      </Pagination>
    </div>
  );
};

export default PaginationComponent;


